import api from '../callApi';
import config from '../../config';

// this makes sure that we fetch once
let request;

const apiUrl = config.API_BASE_URL + 'Localization/GetLocation/';

function mapFreegeoipResponse(json) {
    if (!json) return null;

    return {
        countryCode: json.countryCode,
        countryName: json.country,
        ip: json.query,
        latitude: json.lat,
        longitude: json.lon,
        postalCode: json.zip,
        region: json.region,
        regionName: json.regionName
    };
}

function getGeoIpData() {
    if (!request) {
        request = api.get(apiUrl).then(json => {
            const ret = mapFreegeoipResponse(json);
            if (!ret) throw json;
            return ret;
        });
    }
    return request;
}

export default getGeoIpData;



// WEBPACK FOOTER //
// ./src/utils/localRepresentative/geoip-service.js